// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.equipamentos-container {
    display: flex;
    flex-direction: column;
    min-height: 100%;
}

.filter-buttons {
    display: flex;
    gap: 10px;
}

.filter-btn {
    padding: 8px 16px;
    border: 1px solid #ddd;
    background: white;
    border-radius: 6px;
    cursor: pointer;
    font-size: 0.85rem;
    transition: all 0.2s;
}

.filter-btn:hover {
    border-color: #667eea;
}

.filter-btn.active {
    background: #667eea;
    color: white;
    border-color: #667eea;
}

/* Tabela */
.equipamentos-table-container {
    background: white;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    overflow: hidden;
}

.equipamentos-table {
    width: 100%;
    border-collapse: collapse;
}


.equipamentos-table th {
    padding: 1rem;
    text-align: left;
    font-weight: 600;
    font-size: 0.9rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.equipamentos-table tbody tr {
    border-bottom: 1px solid #f0f0f0;
    transition: background-color 0.2s ease;
}

.equipamentos-table tbody tr:hover {
    background-color: #f8f9ff;
}

.equipamentos-table td {
    padding: 1rem;
    color: #333;
}

.badge {
    padding: 0.25rem 0.75rem;
    border-radius: 20px;
    font-size: 0.85rem;
    font-weight: 600;
    display: inline-block;
}

.badge-proprio {
    background-color: #e3f2fd;
    color: #1976d2;
}

.badge-alugado {
    background-color: #fff3e0;
    color: #f57c00;
}

.actions-cell {
    display: flex;
    gap: 0.5rem;
}

.btn-edit,
.btn-delete {
    background: none;
    border: none;
    font-size: 1.2rem;
    cursor: pointer;
    padding: 0.25rem 0.5rem;
    border-radius: 4px;
    transition: all 0.2s ease;
}

.btn-edit:hover {
    background-color: #e3f2fd;
    transform: scale(1.1);
}

.btn-delete:hover {
    background-color: #ffebee;
    transform: scale(1.1);
}

.empty-message {
    text-align: center;
    padding: 3rem !important;
    color: #999;
    font-style: italic;
}

/* Modal */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1100;
    padding: 1rem;
    overflow-y: auto;
}

.equipamento-modal-content {
    background: white;
    border-radius: 16px;
    width: 100%;
    max-width: 900px;
    display: flex;
    flex-direction: column;
    height: 85vh;
    max-height: 90vh;
    /* Restore limit to prevent overflowing screen */
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
    animation: modalSlideIn 0.3s ease;
    overflow: hidden;
    /* Important: internal body will handle scrolling */
    margin: auto;
}

@keyframes modalSlideIn {
    from {
        opacity: 0;
        transform: translateY(-50px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.5rem 2rem;
    border-bottom: 2px solid #f0f0f0;
    position: sticky;
    top: 0;
    background: white;
    z-index: 10;
}

.modal-header h2 {
    margin: 0;
    color: #1a1a1a;
    font-size: 1.5rem;
}

.btn-close {
    background: none;
    border: none;
    font-size: 1.5rem;
    cursor: pointer;
    color: #999;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    transition: all 0.2s ease;
}

.btn-close:hover {
    background-color: #f0f0f0;
    color: #333;
}

/* Tabs */
.modal-tabs {
    display: flex;
    background-color: #f8f9fa;
    padding: 0 1rem;
    border-bottom: 2px solid #f0f0f0;
    gap: 0.5rem;
    position: sticky;
    top: 68px;
    z-index: 9;
}

.tab-btn {
    padding: 1rem 1.5rem;
    border: none;
    background: none;
    font-weight: 600;
    color: #666;
    cursor: pointer;
    border-bottom: 3px solid transparent;
    transition: all 0.2s;
    font-size: 0.9rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.tab-btn:hover {
    color: #667eea;
    background-color: rgba(102, 126, 234, 0.05);
}

.tab-btn.active {
    color: #667eea;
    border-bottom-color: #667eea;
}

/* Formulário */
.equipamento-form {
    padding: 0;
    display: flex;
    flex-direction: column;
    flex: 1 1;
    overflow: hidden;
}

.form-body {
    padding: 2rem;
    overflow-y: auto;
    flex: 1 1;
}

/* Custom Scrollbar for Equipment Modal */
.form-body::-webkit-scrollbar {
    width: 8px;
}

.form-body::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
}

.form-body::-webkit-scrollbar-thumb {
    background: #cbd5e0;
    border-radius: 4px;
}

.form-body::-webkit-scrollbar-thumb:hover {
    background: #667eea;
}

.form-section {
    margin-bottom: 2rem;
    padding-bottom: 1.5rem;
    border-bottom: 1px solid #e0e0e0;
}

.form-section:last-of-type {
    border-bottom: none;
}

.form-section h3 {
    color: #667eea;
    font-size: 1.1rem;
    margin: 0 0 1rem 0;
    font-weight: 600;
}

.form-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 1.25rem;
}

.form-group {
    display: flex;
    flex-direction: column;
}

.form-group.full-width {
    grid-column: 1 / -1;
}

.form-group.checkbox-group {
    flex-direction: row;
    align-items: center;
}

.form-group.checkbox-group label {
    display: flex;
    align-items: center;
    cursor: pointer;
    gap: 0.5rem;
}

.form-group label {
    font-weight: 600;
    margin-bottom: 0.5rem;
    color: #333;
    font-size: 0.9rem;
}

.form-group.checkbox-group label {
    margin-bottom: 0;
}

.form-group input[type="text"],
.form-group input[type="number"],
.form-group input[type="date"],
.form-group textarea,
.form-group select {
    padding: 0.75rem;
    border: 2px solid #e0e0e0;
    border-radius: 8px;
    font-size: 1rem;
    font-family: inherit;
    transition: all 0.3s ease;
}

.form-group input[type="checkbox"] {
    width: 20px;
    height: 20px;
    cursor: pointer;
    accent-color: #667eea;
}

.form-group input:focus,
.form-group textarea:focus,
.form-group select:focus {
    outline: none;
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.form-group textarea {
    resize: vertical;
    min-height: 80px;
}

/* Modal Footer */
.modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
    padding: 1.25rem 2rem;
    border-top: 1px solid #e2e8f0;
    background: #f8fafc;
    width: 100%;
}

.btn-cancel {
    padding: 0.75rem 1.5rem;
    border: 2px solid #e0e0e0;
    background: white;
    color: #666;
    border-radius: 8px;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
}

.btn-cancel:hover {
    background-color: #f5f5f5;
    border-color: #ccc;
}

.btn-submit {
    padding: 0.75rem 1.5rem;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}

.btn-submit:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

/* Responsive */
@media (max-width: 768px) {
    .equipamentos-container {
        padding: 1rem;
    }

    .equipamentos-header {
        flex-direction: column;
        gap: 1rem;
        align-items: stretch;
    }

    .equipamentos-filters {
        flex-direction: column;
    }

    .equipamentos-table-container {
        overflow-x: auto;
    }

    .equipamentos-table {
        min-width: 800px;
    }

    .equipamento-modal-content {
        max-width: 100%;
        margin: 0;
        border-radius: 0;
        max-height: 100vh;
    }

    .form-grid {
        grid-template-columns: 1fr;
    }
}

.btn-dl50 {
    background: #48bb78;
    color: white;
    border: none;
    padding: 10px 16px;
    border-radius: 6px;
    font-weight: 600;
    cursor: pointer;
    width: 100%;
    margin-top: 10px;
    transition: background 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}

.btn-dl50:hover {
    background: #38a169;
}
/* Código de inventário estável, legível também fora do tema líquido. */
.eq-code { white-space: nowrap; font-variant-numeric: tabular-nums; color: #426887; font-weight: 400; }
@media screen {
    .app-layout[data-maquetes-theme="liquido"] .main-content[data-liquid-module="equipamentos"] .eq-pill {
        display: inline-flex; align-items: center; gap: 4px; white-space: nowrap;
        padding: 4px 8px !important; border-radius: 8px !important;
        border: 1px solid var(--eq-border, #8ba8c45c) !important;
        background: var(--eq-bg, #668bad1c) !important; color: var(--eq-ink, #526c84) !important;
        font: 600 10px/1.3 'Segoe UI', sans-serif !important; letter-spacing: .15px;
    }
    .eq-pill--blue { --eq-bg: #408de63b; --eq-ink: #205899; --eq-border: #4789ce70; }
    .eq-pill--green { --eq-bg: #38ad7840; --eq-ink: #206644; --eq-border: #40987370; }
    .eq-pill--amber { --eq-bg: #efb33338; --eq-ink: #825009; --eq-border: #c78c3266; }
    .eq-pill--red { --eq-bg: #d66b7433; --eq-ink: #9c3846; --eq-border: #bf627373; }
    .eq-pill--violet { --eq-bg: #9274dc33; --eq-ink: #65508c; --eq-border: #9274dc70; }
    .app-layout[data-maquetes-theme="liquido"] .main-content[data-liquid-module="equipamentos"] .eq-category-select {
        background: #f7fbff !important; color: #426887 !important; border: 1px solid #bed3e9 !important;
        border-radius: 8px !important; font: 400 12px/1.4 'Segoe UI', sans-serif !important;
        padding: 6px 24px 6px 9px !important; min-height: 30px; width: auto;
    }
    .app-layout[data-maquetes-theme="liquido"] .main-content[data-liquid-module="equipamentos"] .btn-edit,
    .app-layout[data-maquetes-theme="liquido"] .main-content[data-liquid-module="equipamentos"] .eq-bulk-button {
        background: #f7fbff !important; color: #426887 !important; border-color: #bed3e9 !important;
    }
}

@media screen {
    .app-layout[data-maquetes-theme="liquido"] .main-content[data-liquid-module="equipamentos"] .eq-bulk-button {
        display: inline-flex; align-items: center; gap: 5px; border-radius: 8px !important; padding: 5px 8px !important; font-size: 11px !important; font-weight: 500 !important; white-space: nowrap;
    }
}

.equipamentos-container .eq-bulk-actions {
    display: flex; align-items: center; gap: 6px; white-space: nowrap;
}
.equipamentos-container .eq-bulk-button {
    display: inline-flex; align-items: center; justify-content: center; gap: 5px;
    min-height: 28px; padding: 5px 8px; border: 1px solid #bed3e9; border-radius: 8px;
    background: #f7fbff; color: #426887; font: 500 11px/1.3 'Segoe UI', sans-serif;
    text-transform: none; letter-spacing: 0; white-space: nowrap; cursor: pointer;
    transition: background .15s, border-color .15s;
}
.equipamentos-container .eq-bulk-button:not(:disabled):hover {
    background: #e4effa !important; border-color: #83aace !important;
}
.equipamentos-container .eq-bulk-button:focus-visible {
    outline: 2px solid #397bb5; outline-offset: 2px;
}
.equipamentos-container .eq-bulk-button:disabled { opacity: .45; cursor: not-allowed; }
.equipamentos-container .eq-bulk-button svg { width: 14px; height: 14px; flex: 0 0 14px; }

/* Mantém a célula na grelha da tabela; o flex aplica-se apenas aos botões.
   Assim o separador fica no fundo da linha inteira e não sob os ícones. */
.equipamentos-table td.eq-actions-cell {
    display: table-cell !important; vertical-align: middle !important;
}
.equipamentos-table .eq-row-actions {
    display: flex; align-items: center; justify-content: center; gap: 8px;
    border: 0; background: transparent;
}

/* The toolbar shares one height; the person icon occupies its own flex column. */
.equipamentos-container .eq-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 20px;
}
.equipamentos-container .eq-toolbar-filters,
.equipamentos-container .eq-toolbar-categories {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
    min-width: 0;
    max-width: 100%;
}
.equipamentos-container .eq-toolbar .shared-subnav.eq-toolbar-segment {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    box-sizing: border-box;
    min-height: 42px;
    max-width: 100%;
    margin: 0;
    padding: 4px !important;
    gap: 4px;
    border: 1px solid #bfd9e980;
    border-radius: 13px;
}
.equipamentos-container .eq-toolbar .eq-toolbar-segment .shared-subnav-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    height: 32px;
    min-height: 32px;
    box-sizing: border-box;
    padding: 0 10px;
    border-radius: 9px;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    transition: background .15s ease, color .15s ease, box-shadow .15s ease;
}
.equipamentos-container .eq-toolbar .app-icon { width: 16px; height: 16px; flex: 0 0 16px; }
.equipamentos-container .eq-toolbar .shared-subnav-btn:focus-visible {
    outline: 2px solid #448ecc;
    outline-offset: 2px;
}
.equipamentos-container .eq-toolbar .eq-view-toggle { margin-left: auto; flex-shrink: 0; }
.equipamentos-container .eq-toolbar .eq-person-filter {
    display: inline-flex;
    align-items: center;
    box-sizing: border-box;
    height: 42px;
    width: 260px;
    max-width: 100%;
    min-width: 0;
    border: 1px solid #a4bfd780;
    border-radius: 13px;
    background: #ffffffbf;
}
.equipamentos-container .eq-toolbar .eq-person-filter-icon {
    display: flex;
    justify-content: center;
    flex: 0 0 34px;
    color: #587a96;
    pointer-events: none;
}
.equipamentos-container .eq-toolbar .eq-person-filter select,
.app-layout[data-maquetes-theme="liquido"] .main-content[data-liquid-module="equipamentos"] .equipamentos-container .eq-toolbar .eq-person-filter select[aria-label] {
    flex: 1 1;
    width: 0;
    min-width: 0;
    height: 40px;
    min-height: 40px;
    padding: 0 8px 0 0 !important;
    border: 0 !important;
    border-radius: 0 12px 12px 0 !important;
    background: transparent !important;
    color: inherit;
    font: inherit;
    font-size: 12px !important;
    text-overflow: ellipsis;
    cursor: pointer;
}
.equipamentos-container .eq-toolbar .eq-person-filter:focus-within { outline: 2px solid #448ecc; outline-offset: 2px; }
.equipamentos-container .eq-toolbar .eq-person-filter select:focus-visible { outline: none; }
.equipamentos-container .eq-toolbar .eq-person-filter.is-filtered { background: #e6f2fc; border-color: #7ca9c9; }
.equipamentos-container .eq-toolbar .eq-pending-filter .shared-subnav-btn:not(.active) { color: #946016; }
.equipamentos-container .eq-toolbar-count {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 22px;
    height: 20px;
    padding: 0 5px;
    box-sizing: border-box;
    border-radius: 6px;
    background: #c78c321c;
    font-size: 11px;
    font-variant-numeric: tabular-nums;
}
.equipamentos-container .active .eq-toolbar-count { background: #ffffff26; color: inherit; }
[data-liquid-module="equipamentos"] .eq-toolbar .eq-toolbar-segment {
    background: linear-gradient(135deg, #f8fcffb8, #e8f3fc80) !important;
    box-shadow: inset 0 1px 0 #ffffffc7, 0 2px 5px #294b6905;
    backdrop-filter: blur(16px);
}
[data-liquid-module="equipamentos"] .eq-toolbar .shared-subnav-btn:hover:not(.active) { background: #ffffffa6; }
[data-liquid-module="equipamentos"] .eq-toolbar .eq-chemicals-shortcut .shared-subnav-btn { color: #306575; }
@media (max-width: 600px) {
    .equipamentos-container .eq-toolbar-filters { width: 100%; }
    .equipamentos-container .eq-toolbar .eq-person-filter { width: 100%; }
    .equipamentos-container .eq-toolbar .eq-toolbar-segment .shared-subnav-btn { padding-inline: 8px; }
}

.eq-editor-subtitle { margin: 6px 0 0; font-size: 12px; color: #68829a; font-weight: 400; }
.eq-editor-history { margin-bottom: 18px; padding: 10px 12px; border: 1px solid #bed3e970; border-radius: 10px; background: #f7fbff70; }
.eq-editor-history p { display: flex; align-items: center; gap: 6px; margin: 3px 0; font-size: 12px; line-height: 1.5; color: #68829a; }
[data-liquid-dialog][data-orc-theme="liquido"] .eq-editor {
    height: min(780px, calc(100dvh - 32px)); max-width: 860px; overflow: hidden !important; min-height: 0;
}
[data-liquid-dialog][data-orc-theme="liquido"] .eq-editor .modal-header { position: static; flex: 0 0 auto; padding: 20px 24px; }
[data-liquid-dialog][data-orc-theme="liquido"] .eq-editor .modal-header h2 { display: flex; align-items: center; gap: 9px; }
[data-liquid-dialog][data-orc-theme="liquido"] .eq-editor .modal-tabs { position: static; flex: 0 0 auto; margin: 16px 24px; width: fit-content; max-width: calc(100% - 48px); overflow-x: auto; }
[data-liquid-dialog][data-orc-theme="liquido"] .eq-editor .tab-btn { padding: 8px 12px; font-size: 12px; font-weight: 500; color: #426685; border: 0; white-space: nowrap; border-radius: 9px; }
[data-liquid-dialog][data-orc-theme="liquido"] .eq-editor .equipamento-form { min-height: 0; margin: 0; }
[data-liquid-dialog][data-orc-theme="liquido"] .eq-editor .form-body { min-height: 0; padding: 4px 24px 22px; overflow: auto; scrollbar-gutter: stable; }
[data-liquid-dialog][data-orc-theme="liquido"] .eq-editor .form-section { background: transparent !important; border: 0 !important; box-shadow: none !important; padding: 0; margin: 0; }
[data-liquid-dialog][data-orc-theme="liquido"] .eq-editor .form-section h3 { display: flex; align-items: center; gap: 6px; color: #426685 !important; font-size: 14px; font-weight: 500; padding: 0 0 12px; margin: 0 0 18px; border-bottom: 1px solid #bed3e970; }
[data-liquid-dialog][data-orc-theme="liquido"] .eq-editor .form-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 18px 20px; align-items: start; }
[data-liquid-dialog][data-orc-theme="liquido"] .eq-editor .form-group { min-width: 0; gap: 6px; padding: 0; margin: 0; }
[data-liquid-dialog][data-orc-theme="liquido"] .eq-editor .form-group label { margin: 0; line-height: 1.5; }
[data-liquid-dialog][data-orc-theme="liquido"] .eq-editor .form-group small { font-size: 11px; line-height: 1.5; color: #6d87a0 !important; }
[data-liquid-dialog][data-orc-theme="liquido"] .eq-editor .checkbox-group { align-self: center; }
[data-liquid-dialog][data-orc-theme="liquido"] .eq-editor .modal-footer { flex: 0 0 auto; position: static; width: auto; margin: 0; gap: 10px; padding: 16px 24px; }
[data-liquid-dialog][data-orc-theme="liquido"] .eq-editor .modal-footer button { display: inline-flex; align-items: center; justify-content: center; gap: 6px; width: auto !important; flex: 0 0 auto !important; min-width: 100px; margin: 0; }
@media (max-width: 600px) {
    [data-liquid-dialog][data-orc-theme="liquido"] .eq-editor .form-grid { grid-template-columns: minmax(0, 1fr); }
    [data-liquid-dialog][data-orc-theme="liquido"] .eq-editor .modal-header { padding: 16px; }
    [data-liquid-dialog][data-orc-theme="liquido"] .eq-editor .modal-tabs { margin: 12px 16px; max-width: calc(100% - 32px); }
    [data-liquid-dialog][data-orc-theme="liquido"] .eq-editor .form-body { padding: 4px 16px 18px; }
    [data-liquid-dialog][data-orc-theme="liquido"] .eq-editor .modal-footer { padding: 12px 16px; }
}

/* Header preview for Equipamentos: keep the full page in the scroll flow,
   as in Orçamentos, so sticky positioning also holds at the end of the list. */
.app-layout[data-maquetes-theme="liquido"] .main-content[data-liquid-module="equipamentos"] > .equipamentos-container {
    flex: 0 0 auto;
    overflow: visible;
}
.app-layout[data-maquetes-theme="liquido"] .main-content[data-liquid-module="equipamentos"] .equipamentos-container > .top-bar {
    position: sticky;
    top: 0;
    z-index: 100;
    flex-shrink: 0;
    border-radius: 0 0 0 26px;
    background: linear-gradient(115deg, rgba(238, 247, 255, .78), rgba(235, 245, 255, .66));
    backdrop-filter: blur(22px) saturate(135%);
    -webkit-backdrop-filter: blur(22px) saturate(135%);
    border-bottom: 1px solid rgba(255, 255, 255, .65);
    box-shadow: 0 5px 18px rgba(39, 76, 108, .06), inset 0 -1px 0 rgba(255, 255, 255, .2);
}

/* The action caption inherits the same typography as the other table headings. */
.equipamentos-container .equipamentos-table thead .eq-bulk-actions,
.equipamentos-container .equipamentos-table thead .eq-bulk-actions > span {
    font-family: inherit;
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
    letter-spacing: inherit;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Equipamentos.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;AACzB;;AAEA,WAAW;AACX;IACI,iBAAiB;IACjB,mBAAmB;IACnB,0CAA0C;IAC1C,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;;AAGA;IACI,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;IAChC,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;;IAEI,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,uBAAuB;IACvB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,WAAW;IACX,kBAAkB;AACtB;;AAEA,UAAU;AACV;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;IAChB,gDAAgD;IAChD,0CAA0C;IAC1C,iCAAiC;IACjC,gBAAgB;IAChB,mDAAmD;IACnD,YAAY;AAChB;;AAEA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,oBAAoB;IACpB,gCAAgC;IAChC,gBAAgB;IAChB,MAAM;IACN,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,SAAS;IACT,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA,SAAS;AACT;IACI,aAAa;IACb,yBAAyB;IACzB,eAAe;IACf,gCAAgC;IAChC,WAAW;IACX,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,oBAAoB;IACpB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,oCAAoC;IACpC,oBAAoB;IACpB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,2CAA2C;AAC/C;;AAEA;IACI,cAAc;IACd,4BAA4B;AAChC;;AAEA,eAAe;AACf;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,SAAO;AACX;;AAEA,yCAAyC;AACzC;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;;;;IAKI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,qBAAqB;AACzB;;AAEA;;;IAGI,aAAa;IACb,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,qBAAqB;IACrB,6BAA6B;IAC7B,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,6DAA6D;IAC7D,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,+CAA+C;AACnD;;AAEA;IACI,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA,eAAe;AACf;IACI;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;QACtB,SAAS;QACT,oBAAoB;IACxB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,SAAS;QACT,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,mBAAmB;AACvB;AACA,uEAAuE;AACvE,WAAW,mBAAmB,EAAE,kCAAkC,EAAE,cAAc,EAAE,gBAAgB,EAAE;AACtG;IACI;QACI,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,mBAAmB;QACxE,2BAA2B,EAAE,6BAA6B;QAC1D,wDAAwD;QACxD,8CAA8C,EAAE,wCAAwC;QACxF,oDAAoD,EAAE,qBAAqB;IAC/E;IACA,iBAAiB,kBAAkB,EAAE,iBAAiB,EAAE,sBAAsB,EAAE;IAChF,kBAAkB,kBAAkB,EAAE,iBAAiB,EAAE,sBAAsB,EAAE;IACjF,kBAAkB,kBAAkB,EAAE,iBAAiB,EAAE,sBAAsB,EAAE;IACjF,gBAAgB,kBAAkB,EAAE,iBAAiB,EAAE,sBAAsB,EAAE;IAC/E,mBAAmB,kBAAkB,EAAE,iBAAiB,EAAE,sBAAsB,EAAE;IAClF;QACI,8BAA8B,EAAE,yBAAyB,EAAE,oCAAoC;QAC/F,6BAA6B,EAAE,oDAAoD;QACnF,oCAAoC,EAAE,gBAAgB,EAAE,WAAW;IACvE;IACA;;QAEI,8BAA8B,EAAE,yBAAyB,EAAE,gCAAgC;IAC/F;AACJ;;AAEA;IACI;QACI,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,6BAA6B,EAAE,2BAA2B,EAAE,0BAA0B,EAAE,2BAA2B,EAAE,mBAAmB;IACjM;AACJ;;AAEA;IACI,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,mBAAmB;AACrE;AACA;IACI,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,QAAQ;IAC5E,gBAAgB,EAAE,gBAAgB,EAAE,yBAAyB,EAAE,kBAAkB;IACjF,mBAAmB,EAAE,cAAc,EAAE,yCAAyC;IAC9E,oBAAoB,EAAE,iBAAiB,EAAE,mBAAmB,EAAE,eAAe;IAC7E,8CAA8C;AAClD;AACA;IACI,8BAA8B,EAAE,gCAAgC;AACpE;AACA;IACI,0BAA0B,EAAE,mBAAmB;AACnD;AACA,mDAAmD,YAAY,EAAE,mBAAmB,EAAE;AACtF,8CAA8C,WAAW,EAAE,YAAY,EAAE,cAAc,EAAE;;AAEzF;0EAC0E;AAC1E;IACI,8BAA8B,EAAE,iCAAiC;AACrE;AACA;IACI,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,QAAQ;IACrE,SAAS,EAAE,uBAAuB;AACtC;;AAEA,iFAAiF;AACjF;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,SAAS;IACT,mBAAmB;AACvB;AACA;;IAEI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,SAAS;IACT,YAAY;IACZ,eAAe;AACnB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,SAAS;IACT,uBAAuB;IACvB,QAAQ;IACR,2BAA2B;IAC3B,mBAAmB;AACvB;AACA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,uEAAuE;AAC3E;AACA,gDAAgD,WAAW,EAAE,YAAY,EAAE,cAAc,EAAE;AAC3F;IACI,0BAA0B;IAC1B,mBAAmB;AACvB;AACA,sDAAsD,iBAAiB,EAAE,cAAc,EAAE;AACzF;IACI,oBAAoB;IACpB,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,2BAA2B;IAC3B,mBAAmB;IACnB,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,cAAc;IACd,cAAc;IACd,oBAAoB;AACxB;AACA;;IAEI,SAAO;IACP,QAAQ;IACR,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,6BAA6B;IAC7B,oBAAoB;IACpB,uCAAuC;IACvC,kCAAkC;IAClC,cAAc;IACd,aAAa;IACb,0BAA0B;IAC1B,uBAAuB;IACvB,eAAe;AACnB;AACA,qEAAqE,0BAA0B,EAAE,mBAAmB,EAAE;AACtH,6EAA6E,aAAa,EAAE;AAC5F,oEAAoE,mBAAmB,EAAE,qBAAqB,EAAE;AAChH,yFAAyF,cAAc,EAAE;AACzG;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,cAAc;IACd,sBAAsB;IACtB,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,kCAAkC;AACtC;AACA,oDAAoD,qBAAqB,EAAE,cAAc,EAAE;AAC3F;IACI,oEAAoE;IACpE,wDAAwD;IACxD,2BAA2B;AAC/B;AACA,wFAAwF,qBAAqB,EAAE;AAC/G,4FAA4F,cAAc,EAAE;AAC5G;IACI,8CAA8C,WAAW,EAAE;IAC3D,wDAAwD,WAAW,EAAE;IACrE,6EAA6E,mBAAmB,EAAE;AACtG;;AAEA,sBAAsB,eAAe,EAAE,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE;AAC1F,qBAAqB,mBAAmB,EAAE,kBAAkB,EAAE,2BAA2B,EAAE,mBAAmB,EAAE,qBAAqB,EAAE;AACvI,uBAAuB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,aAAa,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACvI;IACI,uCAAuC,EAAE,gBAAgB,EAAE,2BAA2B,EAAE,aAAa;AACzG;AACA,0EAA0E,gBAAgB,EAAE,cAAc,EAAE,kBAAkB,EAAE;AAChI,6EAA6E,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AAC3H,wEAAwE,gBAAgB,EAAE,cAAc,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,4BAA4B,EAAE,gBAAgB,EAAE;AACjM,qEAAqE,iBAAiB,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,SAAS,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;AAC/L,8EAA8E,aAAa,EAAE,SAAS,EAAE;AACxG,uEAAuE,aAAa,EAAE,sBAAsB,EAAE,cAAc,EAAE,wBAAwB,EAAE;AACxJ,0EAA0E,kCAAkC,EAAE,oBAAoB,EAAE,2BAA2B,EAAE,UAAU,EAAE,SAAS,EAAE;AACxL,6EAA6E,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,yBAAyB,EAAE,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,kCAAkC,EAAE;AAClQ,uEAAuE,gDAAgD,EAAE,cAAc,EAAE,kBAAkB,EAAE;AAC7J,wEAAwE,YAAY,EAAE,QAAQ,EAAE,UAAU,EAAE,SAAS,EAAE;AACvH,8EAA8E,SAAS,EAAE,gBAAgB,EAAE;AAC3G,8EAA8E,eAAe,EAAE,gBAAgB,EAAE,yBAAyB,EAAE;AAC5I,4EAA4E,kBAAkB,EAAE;AAChG,0EAA0E,cAAc,EAAE,gBAAgB,EAAE,WAAW,EAAE,SAAS,EAAE,SAAS,EAAE,kBAAkB,EAAE;AACnK,iFAAiF,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,QAAQ,EAAE,sBAAsB,EAAE,yBAAyB,EAAE,gBAAgB,EAAE,SAAS,EAAE;AAC/O;IACI,uEAAuE,qCAAqC,EAAE;IAC9G,0EAA0E,aAAa,EAAE;IACzF,wEAAwE,iBAAiB,EAAE,4BAA4B,EAAE;IACzH,uEAAuE,sBAAsB,EAAE;IAC/F,0EAA0E,kBAAkB,EAAE;AAClG;;AAEA;+EAC+E;AAC/E;IACI,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,MAAM;IACN,YAAY;IACZ,cAAc;IACd,yBAAyB;IACzB,uFAAuF;IACvF,0CAA0C;IAC1C,kDAAkD;IAClD,iDAAiD;IACjD,qFAAqF;AACzF;;AAEA,iFAAiF;AACjF;;IAEI,oBAAoB;IACpB,kBAAkB;IAClB,oBAAoB;IACpB,oBAAoB;IACpB,uBAAuB;AAC3B","sourcesContent":[".equipamentos-container {\n    display: flex;\n    flex-direction: column;\n    min-height: 100%;\n}\n\n.filter-buttons {\n    display: flex;\n    gap: 10px;\n}\n\n.filter-btn {\n    padding: 8px 16px;\n    border: 1px solid #ddd;\n    background: white;\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: 0.85rem;\n    transition: all 0.2s;\n}\n\n.filter-btn:hover {\n    border-color: #667eea;\n}\n\n.filter-btn.active {\n    background: #667eea;\n    color: white;\n    border-color: #667eea;\n}\n\n/* Tabela */\n.equipamentos-table-container {\n    background: white;\n    border-radius: 12px;\n    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);\n    overflow: hidden;\n}\n\n.equipamentos-table {\n    width: 100%;\n    border-collapse: collapse;\n}\n\n\n.equipamentos-table th {\n    padding: 1rem;\n    text-align: left;\n    font-weight: 600;\n    font-size: 0.9rem;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.equipamentos-table tbody tr {\n    border-bottom: 1px solid #f0f0f0;\n    transition: background-color 0.2s ease;\n}\n\n.equipamentos-table tbody tr:hover {\n    background-color: #f8f9ff;\n}\n\n.equipamentos-table td {\n    padding: 1rem;\n    color: #333;\n}\n\n.badge {\n    padding: 0.25rem 0.75rem;\n    border-radius: 20px;\n    font-size: 0.85rem;\n    font-weight: 600;\n    display: inline-block;\n}\n\n.badge-proprio {\n    background-color: #e3f2fd;\n    color: #1976d2;\n}\n\n.badge-alugado {\n    background-color: #fff3e0;\n    color: #f57c00;\n}\n\n.actions-cell {\n    display: flex;\n    gap: 0.5rem;\n}\n\n.btn-edit,\n.btn-delete {\n    background: none;\n    border: none;\n    font-size: 1.2rem;\n    cursor: pointer;\n    padding: 0.25rem 0.5rem;\n    border-radius: 4px;\n    transition: all 0.2s ease;\n}\n\n.btn-edit:hover {\n    background-color: #e3f2fd;\n    transform: scale(1.1);\n}\n\n.btn-delete:hover {\n    background-color: #ffebee;\n    transform: scale(1.1);\n}\n\n.empty-message {\n    text-align: center;\n    padding: 3rem !important;\n    color: #999;\n    font-style: italic;\n}\n\n/* Modal */\n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.6);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1100;\n    padding: 1rem;\n    overflow-y: auto;\n}\n\n.equipamento-modal-content {\n    background: white;\n    border-radius: 16px;\n    width: 100%;\n    max-width: 900px;\n    display: flex;\n    flex-direction: column;\n    height: 85vh;\n    max-height: 90vh;\n    /* Restore limit to prevent overflowing screen */\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n    animation: modalSlideIn 0.3s ease;\n    overflow: hidden;\n    /* Important: internal body will handle scrolling */\n    margin: auto;\n}\n\n@keyframes modalSlideIn {\n    from {\n        opacity: 0;\n        transform: translateY(-50px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.modal-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 1.5rem 2rem;\n    border-bottom: 2px solid #f0f0f0;\n    position: sticky;\n    top: 0;\n    background: white;\n    z-index: 10;\n}\n\n.modal-header h2 {\n    margin: 0;\n    color: #1a1a1a;\n    font-size: 1.5rem;\n}\n\n.btn-close {\n    background: none;\n    border: none;\n    font-size: 1.5rem;\n    cursor: pointer;\n    color: #999;\n    width: 32px;\n    height: 32px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 8px;\n    transition: all 0.2s ease;\n}\n\n.btn-close:hover {\n    background-color: #f0f0f0;\n    color: #333;\n}\n\n/* Tabs */\n.modal-tabs {\n    display: flex;\n    background-color: #f8f9fa;\n    padding: 0 1rem;\n    border-bottom: 2px solid #f0f0f0;\n    gap: 0.5rem;\n    position: sticky;\n    top: 68px;\n    z-index: 9;\n}\n\n.tab-btn {\n    padding: 1rem 1.5rem;\n    border: none;\n    background: none;\n    font-weight: 600;\n    color: #666;\n    cursor: pointer;\n    border-bottom: 3px solid transparent;\n    transition: all 0.2s;\n    font-size: 0.9rem;\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n}\n\n.tab-btn:hover {\n    color: #667eea;\n    background-color: rgba(102, 126, 234, 0.05);\n}\n\n.tab-btn.active {\n    color: #667eea;\n    border-bottom-color: #667eea;\n}\n\n/* Formulário */\n.equipamento-form {\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    overflow: hidden;\n}\n\n.form-body {\n    padding: 2rem;\n    overflow-y: auto;\n    flex: 1;\n}\n\n/* Custom Scrollbar for Equipment Modal */\n.form-body::-webkit-scrollbar {\n    width: 8px;\n}\n\n.form-body::-webkit-scrollbar-track {\n    background: #f1f1f1;\n    border-radius: 4px;\n}\n\n.form-body::-webkit-scrollbar-thumb {\n    background: #cbd5e0;\n    border-radius: 4px;\n}\n\n.form-body::-webkit-scrollbar-thumb:hover {\n    background: #667eea;\n}\n\n.form-section {\n    margin-bottom: 2rem;\n    padding-bottom: 1.5rem;\n    border-bottom: 1px solid #e0e0e0;\n}\n\n.form-section:last-of-type {\n    border-bottom: none;\n}\n\n.form-section h3 {\n    color: #667eea;\n    font-size: 1.1rem;\n    margin: 0 0 1rem 0;\n    font-weight: 600;\n}\n\n.form-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n    gap: 1.25rem;\n}\n\n.form-group {\n    display: flex;\n    flex-direction: column;\n}\n\n.form-group.full-width {\n    grid-column: 1 / -1;\n}\n\n.form-group.checkbox-group {\n    flex-direction: row;\n    align-items: center;\n}\n\n.form-group.checkbox-group label {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    gap: 0.5rem;\n}\n\n.form-group label {\n    font-weight: 600;\n    margin-bottom: 0.5rem;\n    color: #333;\n    font-size: 0.9rem;\n}\n\n.form-group.checkbox-group label {\n    margin-bottom: 0;\n}\n\n.form-group input[type=\"text\"],\n.form-group input[type=\"number\"],\n.form-group input[type=\"date\"],\n.form-group textarea,\n.form-group select {\n    padding: 0.75rem;\n    border: 2px solid #e0e0e0;\n    border-radius: 8px;\n    font-size: 1rem;\n    font-family: inherit;\n    transition: all 0.3s ease;\n}\n\n.form-group input[type=\"checkbox\"] {\n    width: 20px;\n    height: 20px;\n    cursor: pointer;\n    accent-color: #667eea;\n}\n\n.form-group input:focus,\n.form-group textarea:focus,\n.form-group select:focus {\n    outline: none;\n    border-color: #667eea;\n    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.form-group textarea {\n    resize: vertical;\n    min-height: 80px;\n}\n\n/* Modal Footer */\n.modal-footer {\n    display: flex;\n    justify-content: flex-end;\n    gap: 1rem;\n    padding: 1.25rem 2rem;\n    border-top: 1px solid #e2e8f0;\n    background: #f8fafc;\n    width: 100%;\n}\n\n.btn-cancel {\n    padding: 0.75rem 1.5rem;\n    border: 2px solid #e0e0e0;\n    background: white;\n    color: #666;\n    border-radius: 8px;\n    font-size: 1rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n}\n\n.btn-cancel:hover {\n    background-color: #f5f5f5;\n    border-color: #ccc;\n}\n\n.btn-submit {\n    padding: 0.75rem 1.5rem;\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    color: white;\n    border: none;\n    border-radius: 8px;\n    font-size: 1rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);\n}\n\n.btn-submit:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n    .equipamentos-container {\n        padding: 1rem;\n    }\n\n    .equipamentos-header {\n        flex-direction: column;\n        gap: 1rem;\n        align-items: stretch;\n    }\n\n    .equipamentos-filters {\n        flex-direction: column;\n    }\n\n    .equipamentos-table-container {\n        overflow-x: auto;\n    }\n\n    .equipamentos-table {\n        min-width: 800px;\n    }\n\n    .equipamento-modal-content {\n        max-width: 100%;\n        margin: 0;\n        border-radius: 0;\n        max-height: 100vh;\n    }\n\n    .form-grid {\n        grid-template-columns: 1fr;\n    }\n}\n\n.btn-dl50 {\n    background: #48bb78;\n    color: white;\n    border: none;\n    padding: 10px 16px;\n    border-radius: 6px;\n    font-weight: 600;\n    cursor: pointer;\n    width: 100%;\n    margin-top: 10px;\n    transition: background 0.2s;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n}\n\n.btn-dl50:hover {\n    background: #38a169;\n}\n/* Código de inventário estável, legível também fora do tema líquido. */\n.eq-code { white-space: nowrap; font-variant-numeric: tabular-nums; color: #426887; font-weight: 400; }\n@media screen {\n    .app-layout[data-maquetes-theme=\"liquido\"] .main-content[data-liquid-module=\"equipamentos\"] .eq-pill {\n        display: inline-flex; align-items: center; gap: 4px; white-space: nowrap;\n        padding: 4px 8px !important; border-radius: 8px !important;\n        border: 1px solid var(--eq-border, #8ba8c45c) !important;\n        background: var(--eq-bg, #668bad1c) !important; color: var(--eq-ink, #526c84) !important;\n        font: 600 10px/1.3 'Segoe UI', sans-serif !important; letter-spacing: .15px;\n    }\n    .eq-pill--blue { --eq-bg: #408de63b; --eq-ink: #205899; --eq-border: #4789ce70; }\n    .eq-pill--green { --eq-bg: #38ad7840; --eq-ink: #206644; --eq-border: #40987370; }\n    .eq-pill--amber { --eq-bg: #efb33338; --eq-ink: #825009; --eq-border: #c78c3266; }\n    .eq-pill--red { --eq-bg: #d66b7433; --eq-ink: #9c3846; --eq-border: #bf627373; }\n    .eq-pill--violet { --eq-bg: #9274dc33; --eq-ink: #65508c; --eq-border: #9274dc70; }\n    .app-layout[data-maquetes-theme=\"liquido\"] .main-content[data-liquid-module=\"equipamentos\"] .eq-category-select {\n        background: #f7fbff !important; color: #426887 !important; border: 1px solid #bed3e9 !important;\n        border-radius: 8px !important; font: 400 12px/1.4 'Segoe UI', sans-serif !important;\n        padding: 6px 24px 6px 9px !important; min-height: 30px; width: auto;\n    }\n    .app-layout[data-maquetes-theme=\"liquido\"] .main-content[data-liquid-module=\"equipamentos\"] .btn-edit,\n    .app-layout[data-maquetes-theme=\"liquido\"] .main-content[data-liquid-module=\"equipamentos\"] .eq-bulk-button {\n        background: #f7fbff !important; color: #426887 !important; border-color: #bed3e9 !important;\n    }\n}\n\n@media screen {\n    .app-layout[data-maquetes-theme=\"liquido\"] .main-content[data-liquid-module=\"equipamentos\"] .eq-bulk-button {\n        display: inline-flex; align-items: center; gap: 5px; border-radius: 8px !important; padding: 5px 8px !important; font-size: 11px !important; font-weight: 500 !important; white-space: nowrap;\n    }\n}\n\n.equipamentos-container .eq-bulk-actions {\n    display: flex; align-items: center; gap: 6px; white-space: nowrap;\n}\n.equipamentos-container .eq-bulk-button {\n    display: inline-flex; align-items: center; justify-content: center; gap: 5px;\n    min-height: 28px; padding: 5px 8px; border: 1px solid #bed3e9; border-radius: 8px;\n    background: #f7fbff; color: #426887; font: 500 11px/1.3 'Segoe UI', sans-serif;\n    text-transform: none; letter-spacing: 0; white-space: nowrap; cursor: pointer;\n    transition: background .15s, border-color .15s;\n}\n.equipamentos-container .eq-bulk-button:not(:disabled):hover {\n    background: #e4effa !important; border-color: #83aace !important;\n}\n.equipamentos-container .eq-bulk-button:focus-visible {\n    outline: 2px solid #397bb5; outline-offset: 2px;\n}\n.equipamentos-container .eq-bulk-button:disabled { opacity: .45; cursor: not-allowed; }\n.equipamentos-container .eq-bulk-button svg { width: 14px; height: 14px; flex: 0 0 14px; }\n\n/* Mantém a célula na grelha da tabela; o flex aplica-se apenas aos botões.\n   Assim o separador fica no fundo da linha inteira e não sob os ícones. */\n.equipamentos-table td.eq-actions-cell {\n    display: table-cell !important; vertical-align: middle !important;\n}\n.equipamentos-table .eq-row-actions {\n    display: flex; align-items: center; justify-content: center; gap: 8px;\n    border: 0; background: transparent;\n}\n\n/* The toolbar shares one height; the person icon occupies its own flex column. */\n.equipamentos-container .eq-toolbar {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    gap: 12px;\n    margin-bottom: 20px;\n}\n.equipamentos-container .eq-toolbar-filters,\n.equipamentos-container .eq-toolbar-categories {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 10px;\n    min-width: 0;\n    max-width: 100%;\n}\n.equipamentos-container .eq-toolbar .shared-subnav.eq-toolbar-segment {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    box-sizing: border-box;\n    min-height: 42px;\n    max-width: 100%;\n    margin: 0;\n    padding: 4px !important;\n    gap: 4px;\n    border: 1px solid #bfd9e980;\n    border-radius: 13px;\n}\n.equipamentos-container .eq-toolbar .eq-toolbar-segment .shared-subnav-btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    height: 32px;\n    min-height: 32px;\n    box-sizing: border-box;\n    padding: 0 10px;\n    border-radius: 9px;\n    line-height: 1;\n    white-space: nowrap;\n    cursor: pointer;\n    transition: background .15s ease, color .15s ease, box-shadow .15s ease;\n}\n.equipamentos-container .eq-toolbar .app-icon { width: 16px; height: 16px; flex: 0 0 16px; }\n.equipamentos-container .eq-toolbar .shared-subnav-btn:focus-visible {\n    outline: 2px solid #448ecc;\n    outline-offset: 2px;\n}\n.equipamentos-container .eq-toolbar .eq-view-toggle { margin-left: auto; flex-shrink: 0; }\n.equipamentos-container .eq-toolbar .eq-person-filter {\n    display: inline-flex;\n    align-items: center;\n    box-sizing: border-box;\n    height: 42px;\n    width: 260px;\n    max-width: 100%;\n    min-width: 0;\n    border: 1px solid #a4bfd780;\n    border-radius: 13px;\n    background: #ffffffbf;\n}\n.equipamentos-container .eq-toolbar .eq-person-filter-icon {\n    display: flex;\n    justify-content: center;\n    flex: 0 0 34px;\n    color: #587a96;\n    pointer-events: none;\n}\n.equipamentos-container .eq-toolbar .eq-person-filter select,\n.app-layout[data-maquetes-theme=\"liquido\"] .main-content[data-liquid-module=\"equipamentos\"] .equipamentos-container .eq-toolbar .eq-person-filter select[aria-label] {\n    flex: 1;\n    width: 0;\n    min-width: 0;\n    height: 40px;\n    min-height: 40px;\n    padding: 0 8px 0 0 !important;\n    border: 0 !important;\n    border-radius: 0 12px 12px 0 !important;\n    background: transparent !important;\n    color: inherit;\n    font: inherit;\n    font-size: 12px !important;\n    text-overflow: ellipsis;\n    cursor: pointer;\n}\n.equipamentos-container .eq-toolbar .eq-person-filter:focus-within { outline: 2px solid #448ecc; outline-offset: 2px; }\n.equipamentos-container .eq-toolbar .eq-person-filter select:focus-visible { outline: none; }\n.equipamentos-container .eq-toolbar .eq-person-filter.is-filtered { background: #e6f2fc; border-color: #7ca9c9; }\n.equipamentos-container .eq-toolbar .eq-pending-filter .shared-subnav-btn:not(.active) { color: #946016; }\n.equipamentos-container .eq-toolbar-count {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 22px;\n    height: 20px;\n    padding: 0 5px;\n    box-sizing: border-box;\n    border-radius: 6px;\n    background: #c78c321c;\n    font-size: 11px;\n    font-variant-numeric: tabular-nums;\n}\n.equipamentos-container .active .eq-toolbar-count { background: #ffffff26; color: inherit; }\n[data-liquid-module=\"equipamentos\"] .eq-toolbar .eq-toolbar-segment {\n    background: linear-gradient(135deg, #f8fcffb8, #e8f3fc80) !important;\n    box-shadow: inset 0 1px 0 #ffffffc7, 0 2px 5px #294b6905;\n    backdrop-filter: blur(16px);\n}\n[data-liquid-module=\"equipamentos\"] .eq-toolbar .shared-subnav-btn:hover:not(.active) { background: #ffffffa6; }\n[data-liquid-module=\"equipamentos\"] .eq-toolbar .eq-chemicals-shortcut .shared-subnav-btn { color: #306575; }\n@media (max-width: 600px) {\n    .equipamentos-container .eq-toolbar-filters { width: 100%; }\n    .equipamentos-container .eq-toolbar .eq-person-filter { width: 100%; }\n    .equipamentos-container .eq-toolbar .eq-toolbar-segment .shared-subnav-btn { padding-inline: 8px; }\n}\n\n.eq-editor-subtitle { margin: 6px 0 0; font-size: 12px; color: #68829a; font-weight: 400; }\n.eq-editor-history { margin-bottom: 18px; padding: 10px 12px; border: 1px solid #bed3e970; border-radius: 10px; background: #f7fbff70; }\n.eq-editor-history p { display: flex; align-items: center; gap: 6px; margin: 3px 0; font-size: 12px; line-height: 1.5; color: #68829a; }\n[data-liquid-dialog][data-orc-theme=\"liquido\"] .eq-editor {\n    height: min(780px, calc(100dvh - 32px)); max-width: 860px; overflow: hidden !important; min-height: 0;\n}\n[data-liquid-dialog][data-orc-theme=\"liquido\"] .eq-editor .modal-header { position: static; flex: 0 0 auto; padding: 20px 24px; }\n[data-liquid-dialog][data-orc-theme=\"liquido\"] .eq-editor .modal-header h2 { display: flex; align-items: center; gap: 9px; }\n[data-liquid-dialog][data-orc-theme=\"liquido\"] .eq-editor .modal-tabs { position: static; flex: 0 0 auto; margin: 16px 24px; width: fit-content; max-width: calc(100% - 48px); overflow-x: auto; }\n[data-liquid-dialog][data-orc-theme=\"liquido\"] .eq-editor .tab-btn { padding: 8px 12px; font-size: 12px; font-weight: 500; color: #426685; border: 0; white-space: nowrap; border-radius: 9px; }\n[data-liquid-dialog][data-orc-theme=\"liquido\"] .eq-editor .equipamento-form { min-height: 0; margin: 0; }\n[data-liquid-dialog][data-orc-theme=\"liquido\"] .eq-editor .form-body { min-height: 0; padding: 4px 24px 22px; overflow: auto; scrollbar-gutter: stable; }\n[data-liquid-dialog][data-orc-theme=\"liquido\"] .eq-editor .form-section { background: transparent !important; border: 0 !important; box-shadow: none !important; padding: 0; margin: 0; }\n[data-liquid-dialog][data-orc-theme=\"liquido\"] .eq-editor .form-section h3 { display: flex; align-items: center; gap: 6px; color: #426685 !important; font-size: 14px; font-weight: 500; padding: 0 0 12px; margin: 0 0 18px; border-bottom: 1px solid #bed3e970; }\n[data-liquid-dialog][data-orc-theme=\"liquido\"] .eq-editor .form-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 18px 20px; align-items: start; }\n[data-liquid-dialog][data-orc-theme=\"liquido\"] .eq-editor .form-group { min-width: 0; gap: 6px; padding: 0; margin: 0; }\n[data-liquid-dialog][data-orc-theme=\"liquido\"] .eq-editor .form-group label { margin: 0; line-height: 1.5; }\n[data-liquid-dialog][data-orc-theme=\"liquido\"] .eq-editor .form-group small { font-size: 11px; line-height: 1.5; color: #6d87a0 !important; }\n[data-liquid-dialog][data-orc-theme=\"liquido\"] .eq-editor .checkbox-group { align-self: center; }\n[data-liquid-dialog][data-orc-theme=\"liquido\"] .eq-editor .modal-footer { flex: 0 0 auto; position: static; width: auto; margin: 0; gap: 10px; padding: 16px 24px; }\n[data-liquid-dialog][data-orc-theme=\"liquido\"] .eq-editor .modal-footer button { display: inline-flex; align-items: center; justify-content: center; gap: 6px; width: auto !important; flex: 0 0 auto !important; min-width: 100px; margin: 0; }\n@media (max-width: 600px) {\n    [data-liquid-dialog][data-orc-theme=\"liquido\"] .eq-editor .form-grid { grid-template-columns: minmax(0, 1fr); }\n    [data-liquid-dialog][data-orc-theme=\"liquido\"] .eq-editor .modal-header { padding: 16px; }\n    [data-liquid-dialog][data-orc-theme=\"liquido\"] .eq-editor .modal-tabs { margin: 12px 16px; max-width: calc(100% - 32px); }\n    [data-liquid-dialog][data-orc-theme=\"liquido\"] .eq-editor .form-body { padding: 4px 16px 18px; }\n    [data-liquid-dialog][data-orc-theme=\"liquido\"] .eq-editor .modal-footer { padding: 12px 16px; }\n}\n\n/* Header preview for Equipamentos: keep the full page in the scroll flow,\n   as in Orçamentos, so sticky positioning also holds at the end of the list. */\n.app-layout[data-maquetes-theme=\"liquido\"] .main-content[data-liquid-module=\"equipamentos\"] > .equipamentos-container {\n    flex: 0 0 auto;\n    overflow: visible;\n}\n.app-layout[data-maquetes-theme=\"liquido\"] .main-content[data-liquid-module=\"equipamentos\"] .equipamentos-container > .top-bar {\n    position: sticky;\n    top: 0;\n    z-index: 100;\n    flex-shrink: 0;\n    border-radius: 0 0 0 26px;\n    background: linear-gradient(115deg, rgba(238, 247, 255, .78), rgba(235, 245, 255, .66));\n    backdrop-filter: blur(22px) saturate(135%);\n    -webkit-backdrop-filter: blur(22px) saturate(135%);\n    border-bottom: 1px solid rgba(255, 255, 255, .65);\n    box-shadow: 0 5px 18px rgba(39, 76, 108, .06), inset 0 -1px 0 rgba(255, 255, 255, .2);\n}\n\n/* The action caption inherits the same typography as the other table headings. */\n.equipamentos-container .equipamentos-table thead .eq-bulk-actions,\n.equipamentos-container .equipamentos-table thead .eq-bulk-actions > span {\n    font-family: inherit;\n    font-size: inherit;\n    font-weight: inherit;\n    line-height: inherit;\n    letter-spacing: inherit;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
